import * as React from 'react'
import {
  Avatar,
  Box,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Paper,
  styled,
  Tab,
  Tabs,
} from '@design/pt-ui'

import { AdminFilterHook } from './Filter'
import UserPageLayout from './UserPageLayout'
import { translateWithUserLocale } from '../../utils/i18n'
import { AdvertiserUser } from '../../interfaces/entities/user'

function a11yProps(index: any) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  }
}

const StyledPaper = styled(Paper)(({ theme }) => ({
  display: 'flex',
  padding: theme.spacing(0.5),
  margin: theme.spacing(0.5),
  height: '100%',
  alignItems: 'flex-start',
}))

const StyledTabs = styled(Tabs)(({ theme }) => ({
  borderRight: `1px solid ${theme.palette.divider}`,
  textTransform: 'none',
}))

const StyledTab = styled(Tab)({
  textTransform: 'none',
  '&.Mui-selected': {
    backgroundColor: '#f6f6f6',
    borderRight: 'none',
    opacity: 0.7,
  },
})

interface IProps {
  adminFilter: AdminFilterHook
}

const PermissionPage = (props: IProps) => {
  const [value, setValue] = React.useState(-1)

  const handleChange = (_event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue)
  }

  const selectedClient = props.adminFilter.state.selectedClient

  const users = (props.adminFilter.state.users || []).sort(
    (u1: AdvertiserUser, u2: AdvertiserUser) => {
      if (
        (u1.firstName + ' ' + u1.lastName).toLowerCase() >
        (u2.firstName + ' ' + u2.lastName).toLowerCase()
      ) {
        return 1
      }
      if (
        (u1.firstName + ' ' + u2.lastName).toLowerCase() <
        (u2.firstName + ' ' + u2.lastName).toLowerCase()
      ) {
        return -1
      }
      return 0
    },
  )

  return (
    <StyledPaper>
      {selectedClient === null ? (
        <Box
          sx={{
            padding: '48px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
          }}>
          <h3>{translateWithUserLocale('user.management_client_info_text')}</h3>
        </Box>
      ) : (
        <>
          <Box sx={{ minWidth: 240, height: 'calc(100vh - 260px)' }}>
            <StyledTabs
              orientation="vertical"
              indicatorColor="primary"
              variant="scrollable"
              scrollButtons="auto"
              value={value}
              onChange={handleChange}
              aria-label="Vertical tabs example"
              sx={{ width: '100%', height: '99%' }}>
              {users.map((u) => {
                return (
                  <StyledTab
                    key={u.id}
                    sx={{ width: '100%', alignItems: 'flex-start' }}
                    label={
                      <ListItemButton
                        sx={{ width: '100%' }}
                        alignItems="flex-start"
                        onClick={() => props.adminFilter.handleUserSelect(u)}>
                        <ListItemAvatar>
                          <Avatar src="">{`${u.firstName[0]}${u.lastName[0]}`}</Avatar>
                        </ListItemAvatar>
                        <ListItemText
                          primary={`${u.firstName} ${u.lastName}`}
                        />
                      </ListItemButton>
                    }
                    {...a11yProps(0)}
                  />
                )
              })}
            </StyledTabs>
          </Box>
          <Box
            sx={{
              paddingLeft: '15px',
              width: '100%',
              height: '100%',
              overflowY: 'scroll',
            }}>
            <UserPageLayout adminFilter={props.adminFilter} />
          </Box>
        </>
      )}
    </StyledPaper>
  )
}

export default PermissionPage
